module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"viewDetail":"VIEW DETAILS"},"lng_zh":{"viewDetail":"查看詳情"},"lng_th":{"viewDetail":"ดูรายละเอียด"},"lng_id":{"viewDetail":"MELIHAT RINCIAN"},"lng_ko":{"viewDetail":"세부 정보보기"}}')
  delete Component.options._Ctor
}
